import React from "react";
import { apiCall, displayLog } from "../common/common";

const UsersContext = React.createContext();

const rootReducer = (state, action) => {
  switch (action.type) {
    case "GET_USERS":
      return {
        isLoaded: true,
        users: action.payload,
      };

    case "EDIT_USER_STATUS":
      return {
        ...state,
        isLoaded: true,
      };

    case "GET_USER_PROFILE":
      return {
        isLoaded: true,
        profile: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

const UsersProvider = ({ children }) => {
  const [users, setUsers] = React.useReducer(rootReducer, {
    isLoaded: false,
    users: [],
  });
  const [profile, setUserProfile] = React.useReducer(rootReducer, {
    isLoaded: false,
    profile: [],
  });
  return (
    <UsersContext.Provider value={{ users, setUsers, profile, setUserProfile }}>
      {children}
    </UsersContext.Provider>
  );
};

const useUsersState = () => {
  const context = React.useContext(UsersContext);
  return context;
};

//API call to get all users
export async function getUsersRequest(dispatch , enterpriseChanged , id , userData) {
  if(enterpriseChanged){
    const updatedUserData = userData.map(item =>
      item.id === id ? { ...item , role : item.role === 7 ? 1 : 7 } : item
    );
    const data = {
      "code": 1,
      "status": "SUCCESS",
      "message": '',
      "data": updatedUserData
    }
    dispatch({ type: "GET_USERS", payload: data });
    dispatch({ type: "EDIT_USER_STATUS" });
  }
  else{
    let res = await apiCall(
      "GET",
      "GET_USERS",
      "/admin/userList",
      {},
      {},
      {},
      dispatch
    );
    if (res && res.data) {
      if (res.data.code === 0) {
        displayLog(0, res.data.message);
      } else {
        console.log("res.data" , res.data)
        dispatch({ type: "GET_USERS", payload: res.data });
      }
    }
  }
}

//API call to update ban/unban status
export async function updateUserStatus(dispatch, reqData) {
  let res = await apiCall(
    "POST",
    "EDIT_USER_STATUS",
    "/admin/activeDeactiveUsers",
    reqData,
    {},
    {},
    dispatch
  );
  if (res && res.data) {
    if (res.data.code === 0) {
      displayLog(0, res.data.message);
    } else {
      displayLog(1, res.data.message);
      dispatch({ type: "EDIT_USER_STATUS" });
    }
  }
}

//API call to update ban/unban status
export async function updateEnterPriseStatus(dispatch, reqData) {
  let res = await apiCall(
    "POST",
    "EDIT_USER_PROFILE",
    "/admin/appliedEnterprisePlan",
    reqData,
    {},
    {},
    dispatch
  );
  if (res && res.data) {
    if (res.data.code === 0) {
      displayLog(0, res.data.message);
    } else {
      displayLog(1, res.data.message);
      dispatch({ type: "EDIT_USER_STATUS" });
    }
  }
}

//API call to ge particular user profile
export async function getUserProfile(dispatch, reqData) {
  dispatch({ type: "GET_USER_PROFILE", payload: {} });

  let res = await apiCall(
    "GET",
    "GET_USER_PROFILE",
    "/admin/userProfile",
    {},
    {},
    reqData,
    dispatch
  );
  if (res && res.data) {
    if (res.data.code === 0) {
      displayLog(0, res.data.message);
    } else {
      dispatch({ type: "GET_USER_PROFILE", payload: res.data });
    }
  }
}

export { UsersProvider, UsersContext, useUsersState };
